import React from "react";
import withShipment from "../../withShipment";

// styling
import "./Customer.css"

// constants
import {CUSTOMER_PAGES} from "./constants";


import FeedbackBar from "../feedbackBar/FeedbackBar";
import CustomerTable from "./CustomerTable";
import CustomerForm from "./CustomerForm";
import CustomerProfile from "./CustomerProfile";
import {clearStatus} from "../../redux/actions/global";
import PropTypes from "prop-types";
import {
    clearAllCustomers,
    deleteCustomer,
    enrollCustomer, listAllCustomers, listAllHistoricalCustomers,
    previewCustomerFile, restoreHistoricalCustomer,
    saveCustomer, validateCustomerName,
} from '../../redux/actions/customer';
import {customersSelector, historicalCustomersSelector} from "../../redux/selectors/customer";
import {userInfoSelector} from "../../redux/selectors/auth";
import CustomerManualPoint from "./CustomerManualPoint";


class Customer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            customers: [],
            currentPage: CUSTOMER_PAGES.TABLE,
            feedbackBarOpen: false,
            feedbackStatus: '',
            feedbackMessage: '',
            beforeEditRow: null,
            editingRowIndex: null,
            deleteId: "",
            editCustomer: null,
            profileCustomerId: null,
            manualAddPoints: null,
            historicalCustomers: []
        }
    }

    handleDeleteRow = (deleteId) => {
        this.props.deleteCustomer({customerId: deleteId})
    }

    componentDidMount() {
        this.props.listAllCustomers({locationId: this.props.userInfo.selectedLocationId})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.customers !== this.props.customers) {
            this.setState({
                customers: this.props.customers,
                editingRowIndex: null,
            })
        }

         if (prevProps.historicalCustomers !== this.props.historicalCustomers) {
            this.setState({
                historicalCustomers: this.props.historicalCustomers,
                editingRowIndex: null,
            })
        }
    }

    // Clicking "Edit" from the list opens the Profile view.
    handleEditRow = (customer) => {
        this.setState({
            editCustomer: customer,
            profileCustomerId: customer?.customerId || null,
        }, () => {
            this.setCurrentPage(CUSTOMER_PAGES.CUSTOMER_PROFILE)
        })
    }

    handleManualPointRow = (customer) => {
        this.setState({ manualAddPoints: customer }, () => {
            this.setCurrentPage(CUSTOMER_PAGES.MANUAL_POINT, {})
        })
    }

    // Called when the Add Customer form finishes successfully.
    // Navigate to the Profile for the newly-created customer.
    handleAddCustomerSuccess = (savedCustomer) => {
        this.setState({
            editCustomer: savedCustomer || null,
            profileCustomerId: savedCustomer?.customerId || null,
        }, () => {
            this.setCurrentPage(CUSTOMER_PAGES.CUSTOMER_PROFILE)
        })
    }

    handleEditingClear = () => {
        this.setState({ editCustomer: null, profileCustomerId: null }, () => {
            this.setCurrentPage(CUSTOMER_PAGES.TABLE, {})
        })
    }

    setCurrentPage = (newPage) => {
        this.setState({
            currentPage: newPage
        })
    }

    // Find the freshest copy of the profile customer from the Redux-backed list
    resolveProfileCustomer = () => {
        const list = this.state.customers || []
        const id = this.state.profileCustomerId
        if (!id) return this.state.editCustomer
        const fromList = list.find((c) => c.customerId === id)
        return fromList || this.state.editCustomer
    }

    displayTable = () => {
        return (
            <CustomerTable
                handleManualPointRow={this.handleManualPointRow}
                handleEditRow={this.handleEditRow}
                handleDeleteRow={this.handleDeleteRow}
                setCurrentPage={this.setCurrentPage}
                openFeedbackBar={this.openFeedbackBar}
                historicalCustomers={this.state.historicalCustomers}
                clearAllCustomers={this.props.clearAllCustomers}
                user={this.props.userInfo}
                restoreHistoricalCustomer={this.props.restoreHistoricalCustomer}
                listAllHistoricalCustomers={this.props.listAllHistoricalCustomers}

                customers={
                    this.state.showHistorical
                      ? this.state.historicalCustomers
                      : this.state.customers
                }

                isHistorical={this.state.showHistorical}
                showHistorical={() => this.setState({ showHistorical: true },()=>{
                       this.props.listAllHistoricalCustomers( this.props.userInfo.selectedLocationId)
                })}
                hideHistorical={() => this.setState({ showHistorical: false },()=>{
                 this.props.listAllCustomers({locationId: this.props.userInfo.selectedLocationId})
                })}
            />
        )
    }

    displayManualPoint = () => {
        return (
            <CustomerManualPoint
                enrollCustomer={this.props.enrollCustomer}
                previewCustomerFile={this.props.previewCustomerFile}
                customer={this.state.manualAddPoints}
                setCurrentPage={this.setCurrentPage}
                openFeedbackBar={this.openFeedbackBar}
                user={this.props.userInfo}
            />
        )
    }

    displayForm = () => {
        return (
            <CustomerForm
                user={this.props.userInfo}
                previewCustomerFile={this.props.previewCustomerFile}
                handleEditingClear={this.handleEditingClear}
                saveCustomer={this.props.saveCustomer}
                onCustomerSaved={this.handleAddCustomerSuccess}
                setCurrentPage={this.setCurrentPage}
                openFeedbackBar={this.openFeedbackBar}
                validateCustomerName={this.props.validateCustomerName}
            />
        )
    }

    displayProfile = () => {
        const customer = this.resolveProfileCustomer()
        return (
            <CustomerProfile
                user={this.props.userInfo}
                customer={customer}
                previewCustomerFile={this.props.previewCustomerFile}
                saveCustomer={this.props.saveCustomer}
                handleBack={this.handleEditingClear}
                openFeedbackBar={this.openFeedbackBar}
            />
        )
    }

    displayCurrentPage = () => {
        switch (this.state.currentPage) {
            case CUSTOMER_PAGES.TABLE:
                return this.displayTable()
            case CUSTOMER_PAGES.ADD_CUSTOMER:
                return this.displayForm()
            case CUSTOMER_PAGES.MANUAL_POINT:
                return this.displayManualPoint()
            case CUSTOMER_PAGES.CUSTOMER_PROFILE:
                return this.displayProfile()
            default:
                return <div>We encountered an error. Please refresh the page.</div>
        }
    }

    openFeedbackBar = (status,message) => {
        this.setState({feedbackStatus: status, feedbackMessage: message,feedbackBarOpen: true})
    }

    closeFeedbackBar = () => {
        this.setState({ feedbackBarOpen: false, feedbackStatus: '', feedbackMessage:''}, () => {
            this.props.clearStatus()
        })
    }

    render() {
        return (
            <React.Fragment>
                <FeedbackBar
                    open={this.state.feedbackBarOpen}
                    handleClose={this.closeFeedbackBar}
                    severity={this.state.feedbackStatus}
                    message={this.state.feedbackMessage}
                />
                {this.displayCurrentPage()}
            </React.Fragment>
        )
    }
}


const actionCreators = {
    clearStatus,
    deleteCustomer,
    saveCustomer,
    previewCustomerFile,
    enrollCustomer,
    clearAllCustomers,
    listAllCustomers,
    validateCustomerName,

    listAllHistoricalCustomers,
    restoreHistoricalCustomer
}


const mapStateToProps = (state) => ({
    customers: customersSelector(state),
    userInfo: userInfoSelector(state),
    historicalCustomers: historicalCustomersSelector(state),
})


Customer.propTypes = {
    customers: PropTypes.array,
}

Customer.defaultProps = {
    customers: [],
}

export default withShipment({
    mapStateToProps,
    actionCreators
}, Customer);
